import {
  PayPalButtons,
  PayPalButtonsComponentProps,
} from '@paypal/react-paypal-js'
import { BorderType } from 'common/types/styleTypes'
import React, { CSSProperties } from 'react'
import { PaypalBackgroundColorType } from 'src/shared/schemas/payment/paypal-background-color.schema'

export const MAX_PAYPAL_BUTTON_HEIGHT = 55
export const MAX_PAYPAL_BUTTON_WIDTH = 300

export interface CommonPaypalButtonProps
  extends Omit<PayPalButtonsComponentProps, 'style' | 'message'> {
  backgroundColor?: PaypalBackgroundColorType
  height?: number
  width?: CSSProperties['width']
  borderRadius?: Partial<BorderType>
  disabled?: boolean
}

export const CommonPaypalRestButton = ({
  backgroundColor = 'blue',
  height,
  width,
  borderRadius,
  ...rest
}: CommonPaypalButtonProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ maxWidth: width, width: '100%' }}>
        <PayPalButtons
          {...rest}
          style={{
            layout: 'horizontal',
            label: 'paypal',
            shape: 'rect',
            disableMaxWidth: true,
            color: backgroundColor,
            height,
            // PayPal SDK bug workaround: borderRadius=0 doesn't work due to conditional check
            // in PayPal's JS that treats 0 as falsy. Use shape='sharp' instead.
            // https://github.com/paypal/paypal-js/issues/679
            ...(typeof borderRadius === 'number'
              ? { borderRadius }
              : { shape: 'sharp' }),
          }}
          forceReRender={[backgroundColor, height, borderRadius]}
          message={{}}
        />
      </div>
    </div>
  )
}
